/* eslint-disable max-len */

/**
 * Customised appearance variables for the external KYC flow.
 */
export default {
	variables: {
		colorPrimary: '#873EFF',
		colorBackground: '#FFFFFF',
		buttonPrimaryColorBackground: '#3858E9',
		buttonPrimaryColorBorder: '#3858E9',
		buttonPrimaryColorText: '#FFFFFF',
		buttonSecondaryColorBackground: '#FFFFFF',
		buttonSecondaryColorBorder: '#3858E9',
		buttonSecondaryColorText: '#3858E9',
		colorText: '#101517',
		colorSecondaryText: '#50575E',
		actionPrimaryColorText: '#3858E9',
		actionSecondaryColorText: '#101517',
		colorBorder: '#DDDDDD',
		formHighlightColorBorder: '#3858E9',
		formAccentColor: '#3858E9',
		colorDanger: '#CC1818',
		offsetBackgroundColor: '#F0F0F0',
		formBackgroundColor: '#FFFFFF',
		badgeNeutralColorText: '#2C3338',
		badgeNeutralColorBackground: '#F6F7F7',
		badgeNeutralColorBorder: '#F6F7F7',
		badgeSuccessColorText: '#005C12',
		badgeSuccessColorBackground: '#EDFAEF',
		badgeSuccessColorBorder: '#EDFAEF',
		badgeWarningColorText: '#614200',
		badgeWarningColorBackground: '#FCF9E8',
		badgeWarningColorBorder: '#FCF9E8',
		badgeDangerColorText: '#8A2424',
		badgeDangerColorBackground: '#FCF0F1',
		badgeDangerColorBorder: '#FCF0F1',
		borderRadius: '2px',
		buttonBorderRadius: '2px',
		formBorderRadius: '2px',
		badgeBorderRadius: '2px',
		overlayBorderRadius: '8px',
		spacingUnit: '10px',
		fontFamily:
			"-apple-system, BlinkMacSystemFont, 'system-ui', 'Segoe UI', 'Helvetica Neue', 'Helvetica', 'Roboto', 'Arial', sans-serif",
		fontSizeBase: '16px',
		headingXlFontSize: '32px',
		headingXlFontWeight: '400',
		headingLgFontSize: '24px',
		headingLgFontWeight: '400',
		headingMdFontSize: '20px',
		headingMdFontWeight: '400',
		headingSmFontSize: '13px',
		headingSmFontWeight: '600',
		headingXsFontSize: '12px',
		headingXsFontWeight: '600',
		bodyMdFontWeight: '400',
		bodyMdFontSize: '16px',
		bodySmFontSize: '13px',
		bodySmFontWeight: '400',
		labelSmFontSize: '12px', // badge font size to match WPDS
		labelSmFontWeight: '200', // badges font weight to match WPDS
		labelMdFontSize: '13px',
	},
};
